import React from 'react';
import { View } from 'react-native-web';
import {
  Android,
  select_contacts_title,
} from '../../../../../utils/DictionaryManagementUtils';
import SearchContactList from '../../../../ContactList/SearchContactList';
import ShadowingLayout from '../../../../ShadowingLayout';
import FullPageSimulator from '../../FullPageSimulator';
import ArrowInsideSmallSquareBtn from '../../../AuxiliaryComponent/ButtonComponent/ArrowInsideSmallSquareBtn';
import ContactFloatBubble from '../../../../ContactList/ContactFloatBubble';

//= ========================================================================

const SelectRecipientFP = ({
  globJSON, simPlatform, subCategoryId,
  withContactFloatBubble, isPrimaryCtaColorBackground, headlineText = select_contacts_title, isWithArrow,
  withExpand, withTopTitle, withMe, withCircle, withSelected, slideshowRefs = null,
}) => {
  const { recipient } = globJSON.configurations.services[subCategoryId];
  return (
    <FullPageSimulator
      globJSON={globJSON}
      slideshowRefs={slideshowRefs}
      simPlatform={simPlatform}
      scrollDisabled
      withOutPadding
      headlineText={headlineText}
      withTopTitle={withTopTitle}
      floatingChildren={isWithArrow && (
      <View style={{ marginTop: simPlatform === Android ? '100%' : '90%', position: 'absolute' }}>
        <ArrowInsideSmallSquareBtn globJSON={globJSON} isPrimaryCtaColorBackground={isPrimaryCtaColorBackground} />
      </View>
      )}
      WithGrayBackground={!recipient.customer_should_select_recipient_request || (recipient.add_recipient_manually && !recipient.select_from_recipients_list)}
    >
      {withContactFloatBubble
          && <ContactFloatBubble globJSON={globJSON} simPlatform={simPlatform} />}
      <SearchContactList
        globJSON={globJSON}
        subCategoryId={subCategoryId}
        simPlatform={simPlatform}
        withExpand={withExpand}
        withMe={withMe}
        withCircle={withCircle}
        withSelected={withSelected}
      />
    </FullPageSimulator>
  );
};
export default SelectRecipientFP;
